// Auth constants
export const ID_TOKEN_SESSION_KEY = 'id-token';
export const USER_EMAIL = 'login-email';
export const METADATA_SESSION_KEY = 'metadata';
export const EMAIL = 'email';

export const ADDRESS_PATH = '/address';

/**
 * The :id param is actually a span ID, not a group ID.
 * the url for groups has not been implemented yet
 */
export const GROUP_PATH = '/group/:id';

export const LEVEL3_PATH = '/level3/:id';
export const POINT_PATH = '/point/:id';

export const EXPORT_FILETYPES = {
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
};

export const NOT_USED = 'NotUsed';

// TODO: Unify this with Mantine theme breakpoints
// https://linear.app/overstory/issue/OPD-166/consolidate-mantine-and-our-breakpoints
export const SMALL_SCREEN_WIDTH = 1100;
export const NARROW_SCREEN_WIDTH = 1180;
export const MEDIUM_SCREEN_WIDTH = 1300;

export const OVERVIEW_ZOOM_THRESHOLD = 14.5;

export const LISTS_BASE_PATH = '/project';
export const LISTS_DETAIL_PATH = `${LISTS_BASE_PATH}/:id`;
export const LISTS_SPAN_PATH = `${LISTS_DETAIL_PATH}/:spanId`;

/**
 * Every route that renders the map view (the Analysis component). Kept in
 * lockstep with the route table by a test in app/routes.test.ts.
 */
export const PROJECTS_PATH = '/projects';
export const CREATE_PROJECT_PATH = `${PROJECTS_PATH}/new`;
export const PROJECT_DETAIL_PATH = `${PROJECTS_PATH}/:projectId`;
export const PROJECT_SPAN_PATH = `${PROJECT_DETAIL_PATH}/:spanId`;
export const PROJECT_DEMO_PATHS = [
  PROJECTS_PATH,
  CREATE_PROJECT_PATH,
  PROJECT_DETAIL_PATH,
  PROJECT_SPAN_PATH,
] as const;

export const MAP_ROUTE_PATHS = [
  '/',
  LEVEL3_PATH,
  GROUP_PATH,
  ADDRESS_PATH,
  POINT_PATH,
  LISTS_BASE_PATH,
  LISTS_DETAIL_PATH,
  LISTS_SPAN_PATH,
  ...PROJECT_DEMO_PATHS,
] as const;

export const PROGRAM_BASE_PATH = '/program';
export const PROGRAM_PLANS_PATH = `${PROGRAM_BASE_PATH}/:id/plan`;
export const PLAN_DETAIL_PATH = `${PROGRAM_BASE_PATH}/:programId/plan/:planId`;

export const VEGETATION_INTELLIGENCE_PATH = '/dashboard/vegetation';

export const INTERNAL_PATH = '/internal';
export const INTERNAL_DRAFT_DATA_VIEW_PATH = '/internal/draft-data-view';
export const INTERNAL_DATA_VIEW_CREATION_LOG_PATH =
  '/internal/data-view-creation-log';

export const PAGE_TITLE_SUFFIX = ' | Overstory';

export const ALL_NETWORKS = 'all';

export const MAPBOX_STYLE_ID = 'overstory/cmsdabvgf007901su31w7g6ks';
export const MAPBOX_STYLE_URL = `mapbox://styles/${MAPBOX_STYLE_ID}?optimize=true`;
export const VEGETATION_INTELLIGENCE_MAPBOX_STYLE_URL =
  'mapbox://styles/overstory/cmuczzxhq009w01sm5mio7va6?optimize=true';
